import React from 'react';
import useFetchData from '../../../hooks/useFetchData';
import AutocompleteField from '../input/AutocompleteField';

const AutocompleteFieldTemplateAssessment = ({
  onChange,
  value,
  name,
  error,
  label,
  id,
  helperText,
  disabled
}) => {
  const {
    isLoading,
    data,
    error: errorFetch
  } = useFetchData(`/data-entry/templates?type=assessment&skip=0&limit=100000&active=true`);

  return (
    <AutocompleteField
      id={`${id}-autocomplete-assessment`}
      label={label}
      name={name}
      placeholder='Template'
      options={
        data?.paginatedResults?.map((el) => ({
          ...el,
          label: el.title,
          value: el._id
        })) || []
      }
      loading={isLoading}
      error={errorFetch || error}
      helperText={errorFetch?.message || helperText}
      onChange={onChange}
      value={value}
      disabled={disabled}
    />
  );
};

export default AutocompleteFieldTemplateAssessment;
